import React from 'react';

import CloseButton from '@/components/CloseButton/CloseButton';
import {StickyPageLayout} from '@/components/Layout';
import appRouterService from '@/services/route/appRouterService';
import {WARNING_BANNER_SOURCE_TYPES, WarningBanners, WarningBannersTop} from '@/views/WarningBanners';

import ConnectionFinishedContent from './ConnectionFinishedContent';

const ConnectionFinishedMobile = ({onOpenQsg, deviceType}) => {
    const handleClick = () => {
        appRouterService.forwardToDevicesPage(true);
    };

    return (
        <StickyPageLayout
            className='items-center'
            headerOptions={{
                endIcon: <CloseButton onClick={handleClick} />,
            }}
            contentClassName='flex flex-1 flex-col items-center'
            footer={<ConnectionFinishedContent.Buttons onOpenQsg={onOpenQsg} />}
        >
            <WarningBannersTop source={WARNING_BANNER_SOURCE_TYPES.CONNECTION} />
            <ConnectionFinishedContent
                className='pt-safe-offset-sticky-header flex-1 px-6 pb-6'
                deviceType={deviceType}
            />
            <WarningBanners source={WARNING_BANNER_SOURCE_TYPES.CONNECTION} />
        </StickyPageLayout>
    );
};

export default ConnectionFinishedMobile;
